<script setup>
import { RouterLink, RouterView, useRoute } from "vue-router";
import { onMounted } from "vue";
import { useQuizStore } from "@/stores/quiz";
import introImg from "../assets/img/quiz-intro.png";
const quizStore = useQuizStore();
const route = useRoute();
//quizStore.setStatus(props.segmentId, props.questionId);
quizStore.setCurrentRoute(route.name, route.params);
quizStore.setStartedAt(null);
onMounted(() => {
  setTimeout(function () {
    document
      .getElementById("quiz_block")
      .scrollIntoView({ behavior: "smooth" });
  }, 50);
});
</script>

<template>
  <div class="section">
    <div class="container">
      <div class="container__inner px-1.5">
        <div
          class="relative flex flex-col flex-wrap justify-between w-full lg:flex-row"
        >
          <div class="pt-2 lg:w-6/12 lg:pt-4">
            <div class="flex items-center section-title">
              <svg
                width="20"
                height="20"
                class="text-black fill-current mr-0.5 h-0.625 w-0.625 lg:h-1 lg:w-1"
              >
                <use xlink:href="#icon-circle"></use>
              </svg>
              <span class="text-sm uppercase lg:text-base">Mon Ludic</span>
            </div>
            <h1
              class="block m-0 leading-none text-4xl lg:text-8xl font-normal py-1 lg:py-2.5"
              id="quiz_block"
            >
              {{ quizStore.quiz.title }}
            </h1>
            <div
              class="pb-2 entry-content"
              v-html="quizStore.quiz.description"
            ></div>
            <!-- .entry-content -->
            <p>
              <router-link
                class="bt"
                :to="{
                  name: 'segment-question',
                  params: quizStore.nextQuestion(),
                }"
                as="button"
                id="quiz-intro-button"
              >
                <span>Je teste mon niveau</span></router-link
              >
            </p>
          </div>
          <div class="flex items-center lg:w-5/12">
            <img :src="introImg" class="block img-responsive" alt="" />
          </div>
        </div>
        <!-- .flex -->
      </div>
      <!-- .container__inner -->
    </div>
    <!-- .container -->
  </div>
  <!-- .section -->
</template>
